import { useMutation, useQueryClient } from '@tanstack/react-query';

import { deleteContract } from '../../../common/api/clients/contracts.api';
import { queries } from '../../../common/api/queryKeys/queries';

export const useContractDelete = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: deleteContract,
        onSuccess: () => {
            return queryClient.invalidateQueries({ queryKey: queries.contracts._def });
        },
    });
};
